module.exports = __webpack_public_path__ + "images/emoji/moyai.74f5ff7c25974de0d288.png";